import React from 'react'
import JsPDF from 'jspdf'
import 'jspdf-autotable'
import ReactDOMServer from 'react-dom/server'
import DefaultTemplate from './templates/deafult-template'
import * as R from 'ramda'

require('./Roboto-Regular.js')(JsPDF.API)
require('./Circular-normal.js')(JsPDF.API)

export function exportPdf(props) {
  const { header, body, fileName } = props

  let thOrder = {}
  const tableHeader = header.map((item, key) => {
    thOrder[item.id] = key
    return <th key={key}>{item.header}</th>
  })

  let thOrderKeys = Object.keys(thOrder)
  const tableBodyArray = body.map((item) => {
    let arr = []
    thOrderKeys.forEach((propName) => {
      arr[thOrder[propName]] = item[propName] || ''
    })

    return arr
  })

  let tableBody = []
  tableBodyArray.forEach((cellItem, cellItemKey) => {
    let tdArr = []
    cellItem.forEach((rowItem, rowItemKey) => {
      tdArr.push(<td key={rowItemKey}>{rowItem}</td>)
    })
    tableBody.push(<tr key={cellItemKey}>{tdArr}</tr>)
  })

  let pdf = new JsPDF()
  pdf.fromHTML(
    ReactDOMServer.renderToStaticMarkup(
      <DefaultTemplate tableHeader={tableHeader} tableBody={tableBody} />,
    ),
  )
  pdf.save(fileName + '.pdf')
}

export const oreintationTypes = {
  portrait: 'p',
  landscape: 'l',
}

export function exportBeautifulPDF(props) {
  const {
    header,
    body,
    fileName,
    headStyles,
    columnStyles,
    oreintation = oreintationTypes.portrait,
  } = props
  const headerForDoc = R.map(R.values, header)
  const bodyForDoc = R.map(R.values, body)
  let doc = new JsPDF(oreintation, 'pt', 'a4')
  //MARK:- https://github.com/simonbengtsson/jsPDF-AutoTable
  //MARK:- set font https://stackoverflow.com/questions/34232813/jspdf-cannot-set-font-family/46416150
  //MARK: - https://stackoverflow.com/questions/26908266/custom-font-faces-in-jspdf

  doc.autoTable({
    head: [headerForDoc],
    body: bodyForDoc,
    margin: { top: 10, bottom: 10, left: 10, right: 10 },
    headStyles: { fillColor: [17, 42, 56], ...headStyles },
    styles: { font: 'Circular' },
    columnStyles,
  })

  doc.save(fileName)
}
